import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Tag } from 'ngx-web-api';
import { Theme } from '../../domain/theme.model';
import { TagFilteringStyle } from '../../domain/tag-filtering-style.enum';
import { ThemeService } from '../../core/services/theme.service';
import { BreakpointService } from 'app/core/services/breakpoint.service';

@Component({
  selector: 'fts-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
})
export class TagsComponent {
  @Input()
  tags: Tag[];
  @Input()
  isIngredientTag = false;
  @Input()
  inPopover = false;
  @Output()
  tagClicked: EventEmitter<string> = new EventEmitter<string>();

  theme: Theme;
  usesAbbreviations = false;
  renderInButton = false;

  constructor(private themeService: ThemeService, public breakpointService: BreakpointService) {
    this.themeService.theme.subscribe(theme => {
      this.theme = theme;
      this.usesAbbreviations = theme.tagFilteringStyle === TagFilteringStyle.ABBREVIATIONS;
      this.renderInButton = theme.tagFilteringStyle !== TagFilteringStyle.HIDE;
    });
  }

  handleTagClicked(tag: string) {
    if (this.renderInButton) {
      this.tagClicked.emit(tag);
    }
  }
}
